import { render, staticRenderFns } from "./ProducaoProcedimento.vue?vue&type=template&id=6592bb08&scoped=true"
import script from "./ProducaoProcedimento.vue?vue&type=script&lang=ts"
export * from "./ProducaoProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ProducaoProcedimento.vue?vue&type=style&index=0&id=6592bb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592bb08",
  null
  
)

export default component.exports